import { createAsyncThunk } from '@reduxjs/toolkit';

import SignInProcessApi from 'api/curo/SignInProcessApi';
import { SignInProcessActionTypes } from 'enums/curo/SignInProcessActionTypes';
import TokenUtils from 'utils/TokenUtils';
import rejectWithValueHelper from 'utils/rejectWithValueHelper';

export const createLogoutThunk = (api: SignInProcessApi) =>
  createAsyncThunk(SignInProcessActionTypes.SignOut, async (_, thunkApi) => {
    try {
      await api.logout();

      TokenUtils.removeTokens();
    } catch (error) {
      return rejectWithValueHelper(error as Error, thunkApi);
    }
  });
